import * as React from "react";
import { BlogMetaPaper } from "../common/BlogMetaPaper";
import { MetaTitle } from "../common/MetaTitle";
import BookIcon from "@mui/icons-material/Book";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "gatsby";
import { useBlogPosts } from "../../../../data/hooks/useBlogPosts";
import { BlogPostData } from "../../../../data/types/BlogPostData";

export interface IBlogMetaRecentPostsProps {}

export function BlogMetaRecentPosts(props: IBlogMetaRecentPostsProps) {
  const blogPosts = useBlogPosts() as BlogPostData[];
  const latestPosts = blogPosts.slice(0, 3);

  return (
    <BlogMetaPaper>
      <MetaTitle text="Recent Posts" />
      <Box sx={{ marginTop: "16px" }}>
        {latestPosts.map((x) => {
          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "8px",
              }}
              key={x.id}
            >
              <Typography variant="body1" noWrap>
                <Link to={`/blog/${x.slug.current}`}>{x.title}</Link>
              </Typography>
            </Box>
          );
        })}
      </Box>
    </BlogMetaPaper>
  );
}
